import * as fromDatatype from '../datatype-library';

export interface bl_wf_md_process_status_link_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  process_status_guid: fromDatatype.GuidDataFieldInterface;
  process_guid: fromDatatype.GuidDataFieldInterface;
  description: fromDatatype.VarcharDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.RevisionDataFieldInterface;
  namespace: fromDatatype.NamespaceDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  code: fromDatatype.VarcharDatatypeInterface;
  name: fromDatatype.VarcharDatatypeInterface;
  process_resolution_guid: fromDatatype.GuidDataFieldInterface;
  process_resolution_code: fromDatatype.VarcharDatatypeInterface;
  sequence_no: fromDatatype.NumericDatatypeInterface;
}

export class bl_wf_md_process_status_link_RowClass
  implements bl_wf_md_process_status_link_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    process_status_guid: fromDatatype.GuidDataFieldInterface;
    process_guid: fromDatatype.GuidDataFieldInterface;
    description: fromDatatype.VarcharDatatypeInterface;
    status: fromDatatype.StatusDataFieldInterface;
    revision: fromDatatype.RevisionDataFieldInterface;
    vrsn: fromDatatype.RevisionDataFieldInterface;
    namespace: fromDatatype.NamespaceDataFieldInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    code: fromDatatype.VarcharDatatypeInterface;
    name: fromDatatype.VarcharDatatypeInterface;
    process_resolution_guid: fromDatatype.GuidDataFieldInterface;
    process_resolution_code: fromDatatype.VarcharDatatypeInterface;
    sequence_no: fromDatatype.NumericDatatypeInterface;
}
